import { AxiosResponse } from "axios";
import { API } from "../index";

export interface EventAmazingPassInfoImage {
  src: string;
  width?: number;
  height?: number;
}

export interface EventAmazingPassInfo {
  name: string;
  detail: string;
  images: EventAmazingPassInfoImage[];
  target_subdomain_list: string[];
}

export interface EventAmazingPassInfoResponse {
  data: EventAmazingPassInfo;
}

export interface VoucherBookRuleItem {
  id: number;
  voucher_product: {
    id: number;
    name: string;
    image?: string | null;
    precautions?: string;
    expire_date?: string | null;
    expire_days?: number | null;
  };
  stock: number;
  start_date: string;
  end_date: string;
  state: string;
  type: string;
  site: {
    id: number;
    name: string;
    subdomain: string;
  };
  usage_amount: number;
  usage_period_day: number;
}

export interface VoucherBookCheckItem {
  id: number;
  stock: number;
  downloaded: boolean;
  remain: number;
}

export const eventService = {
  getAmazingPassInfo: async (): Promise<AxiosResponse<EventAmazingPassInfoResponse>> => {
    return await API.get(`/ticket/get-event-amazingpass-info/`);
  },

  listVoucherBookRules: async (): Promise<AxiosResponse<VoucherBookRuleItem[]>> => {
    return await API.get(`/voucher/book-rule/`);
  },

  downloadVoucherBook: async (id: number): Promise<AxiosResponse> => {
    return await API.post(`/voucher/book/download/${id}/`);
  },

  getBookRule: async (id: string | number): Promise<AxiosResponse<VoucherBookRuleItem>> => {
    return await API.get(`/voucher/book-rule/${id}/`);
  },

  checkBook: async (id: string | number): Promise<AxiosResponse<VoucherBookCheckItem>> => {
    return await API.get(`/voucher/book/check/${id}/`);
  },

  processEventItem: async (type: "coupon" | "voucher", itemId: string): Promise<AxiosResponse> => {
    return await API.post(`/${type}/process/${itemId}/`);
  },

  getUserNonReceipt: async (type: "coupon" | "voucher"): Promise<AxiosResponse> => {
    return await API.get(`/${type}/user-non-receipt/`);
  }
};
